<style scoped>
.bodywrap{
  height: 100vh;
  background-image: url("../assets/banner-3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.container {
  height: 80vh;

}

.input-field:first-child {
  margin-top: 33%;
}
</style>

<template lang="pug">
  div.bodywrap
    .container.valign-wrapper
      .row
        .col.s12.m6
          .row
            .col.s12.m8.push-m2
              img.responsive-img(src="../assets/inomph_logo.png")
        .col.s12.m6
          .row
            .col.s12.m10.push-m1
              form(@submit='login')
                .input-field
                  input#email(type="text", v-model='email', placeholder='Your email address')
                  label(for="email") Email address
                .input-field
                  input#password(type="password", v-model='password', placeholder='Your password')
                  label(for="password") Password
                button.btn.waves-effect.waves-light(type='submit') Log-in
</template>
<script>
export default {
  meta: {
    title: 'Log-in - Inom.ph Supplier'
  },
  data () {
    return {
      email: null,
      password: null
    }
  },
  mounted () {
    this.$M.updateTextFields()
  },
  methods: {
    login (e) {
      e.preventDefault()
      this.$store
        .dispatch('auth/localLogin', {
          email: this.email,
          password: this.password,
          scope: 'supplier'
        })
        .then(user => {
          if (user.type !== 'supplier') {
            this.$store.dispatch('auth/clear')
            throw new Error('Invalid account')
          }

          this.$router.replace('/')
        })
        .catch(err => {
          this.$snackbar.error(err.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-login.vue